export default function Logo(props) {
  return (
    <div>
      <img src="/site/logo_cabecalho.png" alt="logo cabeçalho" {...props}></img>
    </div>
  );
}
